
import { ChevronDown, ChevronUp } from "lucide-react";
import { UnitCard } from "./UnitCard";

interface SubcategorySectionProps {
  subcategory: string;
  units: string[];
  isExpanded: boolean;
  indentLevel: number;
  onToggle: () => void;
}

export function SubcategorySection({ 
  subcategory, 
  units, 
  isExpanded, 
  indentLevel,
  onToggle 
}: SubcategorySectionProps) {
  return (
    <div className="relative mb-3 last:mb-0 transform transition-all duration-300 hover:translate-y-[-2px]">
      <button
        onClick={onToggle}
        className="flex items-center justify-between w-full gap-2 p-3 
                  bg-gradient-to-r from-manuscript-background/80 to-manuscript-background/60
                  rounded-md shadow-sm border border-manuscript-primary/20
                  hover:shadow-md transition-all duration-300 group
                  relative overflow-hidden"
        aria-expanded={isExpanded}
      >
        <div className="absolute inset-0 bg-manuscript-primary/5 opacity-0 
                      group-hover:opacity-100 transition-opacity duration-300"/>
        <div className="absolute bottom-0 left-0 w-full h-0.5 bg-gradient-to-r 
                     from-manuscript-secondary/80 via-manuscript-secondary to-transparent 
                     transform scale-x-0 group-hover:scale-x-100 transition-transform duration-500 origin-left"/>
        
        <h3 className="text-base font-cinzel text-manuscript-primary/90 relative z-10 truncate 
                      transition-colors duration-200 group-hover:text-manuscript-primary">
          {subcategory}
        </h3>
        <span className="text-manuscript-primary/70 flex-shrink-0 transform transition-all duration-300
                       group-hover:text-manuscript-primary">
          {isExpanded ? (
            <ChevronUp className="w-4 h-4" />
          ) : (
            <ChevronDown className="w-4 h-4" />
          )}
        </span>
      </button>

      {isExpanded && (
        <div className="pl-4 space-y-2 mt-2 animate-fade-in relative
                      before:content-[''] before:absolute before:left-1.5 before:top-0 
                      before:w-0.5 before:h-full before:bg-gradient-to-b 
                      before:from-manuscript-secondary/50 before:via-manuscript-secondary/30 before:to-transparent">
          {Array.isArray(units) && units.map((unit, unitIndex) => (
            <UnitCard 
              key={unit} 
              unit={unit} 
              indentLevel={0}
            />
          ))}
        </div>
      )}
    </div>
  );
}
